"use client";
import { useEffect, useState, useCallback } from "react";
import { isClient, generateStorageKey, EDGEN_TOKEN } from "@aspen/libs";

const shouldShowEdgenAIEntry = (): boolean => {
  const edgenToken = sessionStorage.getItem(generateStorageKey(EDGEN_TOKEN));

  return Boolean(edgenToken);
};

/**
 * Edgen AI 导航入口相关的 hook
 *
 * @returns { showEntry: boolean; getAccessToken: () => string } 是否显示入口和获取 token 的函数
 */
export const useEdgenAIEntry = () => {
  const [showEntry, setShowEntry] = useState<boolean>(() => shouldShowEdgenAIEntry());

  const getAccessToken = useCallback((): string => {
    if (!isClient) {
      return "";
    }
    return sessionStorage.getItem(generateStorageKey(EDGEN_TOKEN)) || "";
  }, []);

  const handleStorageChange = useCallback(() => {
    const nextVisible = shouldShowEdgenAIEntry();
    setShowEntry(prev => {
      if (prev !== nextVisible) {
        return nextVisible;
      }
      return prev;
    });
  }, []);

  useEffect(() => {
    const nextVisible = shouldShowEdgenAIEntry();
    setShowEntry(nextVisible);
  }, []);

  useEffect(() => {
    if (!isClient) {
      return;
    }

    window.addEventListener("storage", handleStorageChange);

    window.addEventListener("sessionStorageChanged", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("sessionStorageChanged", handleStorageChange);
    };
  }, [handleStorageChange]);

  return {
    showEntry,
    getAccessToken,
  };
};
